import React, { useEffect } from 'react'
import { useAppDispatch } from 'app/hooks'
import { SocialWebSourcesWidget } from 'schemas/SocialWebSourcesWidgetSchema'
import { Dashboard } from 'schemas/DashboardSchema'
import useRefreshTimestamp from 'hooks/useRefreshTimestamp'

import { useDashboardData, useDashboardWidgetSetting } from '../../../../hooks/useDashboardState'
import { usePageConfigUser } from '../../../../hooks/usePageConfig'
import { getWidgetForDashboard } from '../../../../features/widget/asyncThunks'
import { createMetric } from '../../../../utils/runSearchUtil'
import { toFilter } from '../../../../utils/widgetUtil'
import { getOptions } from '../../../../utils/timelineUtil'
import { getSearchMetricSeriesList } from './utils'

const createSearch = (
  widgetSetting: SocialWebSourcesWidget,
  dashboardData: Dashboard,
  pageConfigUser: any
) => {
  const filter = toFilter(widgetSetting)

  const { id: dashboardId, name } = dashboardData
  return createMetric(
    dashboardId!,
    name!,
    widgetSetting.precision!,
    [widgetSetting.selectedTopic.topicId!],
    filter,
    getSearchMetricSeriesList(widgetSetting, pageConfigUser),
    getOptions(widgetSetting)
  )
}

const RunSearchEffect = ({
  widgetId,
  children
}: {
  widgetId: number
  children: React.ReactElement
}) => {
  const widgetSetting = useDashboardWidgetSetting<SocialWebSourcesWidget>(widgetId)
  const dashboardData = useDashboardData()
  const pageConfigUser = usePageConfigUser()
  const dispatch = useAppDispatch()
  const refreshTimestamp = useRefreshTimestamp(widgetId)

  useEffect(() => {
    const search = createSearch(widgetSetting, dashboardData!, pageConfigUser)

    dispatch(
      getWidgetForDashboard({
        searches: [search],
        widgetId: widgetSetting.widgetId!,
        timestamp: refreshTimestamp
      })
    )
  }, [widgetSetting, dashboardData, pageConfigUser, dispatch, refreshTimestamp])

  return children
}

export default RunSearchEffect
